/**
 * Deserialize a query param string to a dictionary of *strings* or *Array* of strings
 *  WARNING: ⚠️  This return a Record of String only, you need to parse the object values to the expected primitive after ward
 *  Tip: use zod.
 *
 * @example
 * ```
 * deserializeQueryParams("num=1234&foo=bar&flag=false&none=&arr[]=1&arr[]=2&arr[]=3"); // => {num: 1234, foo: "bar", flag: false, none: "", arr: [1,2,3]})
 * ```
 */
export function deserializeQueryParams(params: string, opts?: Partial<Options>) {
  const fullOpts = opts ? { ...DEFAULT_OPTIONS, ...opts } : DEFAULT_OPTIONS;
  return params
    .split("&")
    .map(unkeyify)
    .reduce(
      (acc, [key, value]) => {
        const outKey = key.includes(fullOpts.arrayPostfix)
          ? key.slice(0, key.length - fullOpts.arrayPostfix.length)
          : key;
        const outValue = acc[outKey];
        if (!outValue) {
          acc[outKey] = value;
        } else {
          if (Array.isArray(outValue)) {
            (acc[outKey] as Array<string>).push(value);
          } else {
            acc[outKey] = [outValue, value];
          }
        }
        return acc;
      },
      {} as Record<string, string | Array<string>>,
    );
}

function unkeyify(pair: string) {
  return pair.split("=").map(decodeURIComponent) as [string, string];
}

type Options = { arrayPostfix: string };
const DEFAULT_OPTIONS: Options = { arrayPostfix: "" };
